module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container-wrapper"
  }, [_c('div', {
    staticClass: "breadcrumb-wrapper"
  }, [_c('span', [_vm._v("勋章配置")]), _vm._v(" "), _c('el-button', {
    staticClass: "back",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-wrapper"
  }, [_c('el-form', {
    ref: "formRef",
    attrs: {
      "label-width": "100px",
      "model": _vm.formData,
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "名称",
      "prop": "badgeName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入名称",
      "maxlength": 100,
      "disabled": _vm.actionType === 'detail'
    },
    model: {
      value: (_vm.formData.badgeName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "badgeName", $$v)
      },
      expression: "formData.badgeName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "成就标识",
      "prop": "badgeId"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入成就标识",
      "maxlength": 100,
      "disabled": _vm.actionType !== 'add'
    },
    model: {
      value: (_vm.formData.badgeId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "badgeId", $$v)
      },
      expression: "formData.badgeId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "达成类型"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.actionType !== 'add'
    },
    model: {
      value: (_vm.formData.badgeType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "badgeType", $$v)
      },
      expression: "formData.badgeType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "按学期",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "按时间",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "达成学期目标",
      "value": 3
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "入学年份",
      "value": 4
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "达成条件",
      "prop": "reachCondition"
    }
  }, [(_vm.formData.badgeType == 1) ? _c('div', {
    staticClass: "flex-row"
  }, [_c('div', {
    staticStyle: {
      "width": "74px"
    }
  }, [_vm._v("学期内跑步")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "number",
      "min": 0,
      "disabled": _vm.actionType === 'detail'
    },
    model: {
      value: (_vm.formData.lengthLimit),
      callback: function($$v) {
        _vm.$set(_vm.formData, "lengthLimit", $$v)
      },
      expression: "formData.lengthLimit"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v(" 公里")])], 1) : _vm._e(), _vm._v(" "), (_vm.formData.badgeType == 2) ? _c('div', {
    staticClass: "flex-row"
  }, [_c('el-date-picker', {
    attrs: {
      "placeholder": "起始日期",
      "disabled": _vm.actionType === 'detail'
    },
    model: {
      value: (_vm.formData.specialStartDate),
      callback: function($$v) {
        _vm.$set(_vm.formData, "specialStartDate", $$v)
      },
      expression: "formData.specialStartDate"
    }
  }), _vm._v(" "), _c('div', [_vm._v(" 至 ")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "placeholder": "截止日期",
      "disabled": _vm.actionType === 'detail'
    },
    model: {
      value: (_vm.formData.specialEndDate),
      callback: function($$v) {
        _vm.$set(_vm.formData, "specialEndDate", $$v)
      },
      expression: "formData.specialEndDate"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "46px"
    }
  }, [_vm._v("  跑步 ")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "number",
      "min": 0,
      "disabled": _vm.actionType === 'detail'
    },
    model: {
      value: (_vm.formData.timesLimit),
      callback: function($$v) {
        _vm.$set(_vm.formData, "timesLimit", $$v)
      },
      expression: "formData.timesLimit"
    }
  }), _vm._v(" "), _c('div', [_vm._v(" 次")])], 1) : _vm._e(), _vm._v(" "), (_vm.formData.badgeType == 3) ? _c('div', {
    staticClass: "flex-row-between"
  }, [_c('el-date-picker', {
    attrs: {
      "placeholder": "起始日期",
      "disabled": _vm.actionType === 'detail'
    },
    model: {
      value: (_vm.formData.startDate),
      callback: function($$v) {
        _vm.$set(_vm.formData, "startDate", $$v)
      },
      expression: "formData.startDate"
    }
  }), _vm._v(" "), _c('div', [_vm._v(" 至 ")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "placeholder": "截止日期",
      "disabled": _vm.actionType === 'detail'
    },
    model: {
      value: (_vm.formData.endDate),
      callback: function($$v) {
        _vm.$set(_vm.formData, "endDate", $$v)
      },
      expression: "formData.endDate"
    }
  }), _vm._v(" "), _c('div', [_vm._v(" 内最长的学期")])], 1) : _vm._e(), _vm._v(" "), (_vm.formData.badgeType == 4) ? _c('div', {
    staticClass: "flex-row"
  }, [_c('div', {
    staticStyle: {
      "width": "60px"
    }
  }, [_vm._v("入学年份")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    model: {
      value: (_vm.formData.caid),
      callback: function($$v) {
        _vm.$set(_vm.formData, "caid", $$v)
      },
      expression: "formData.caid"
    }
  }, _vm._l((_vm.yearOptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "150px"
    }
  }, [_vm._v(" 的学生，首次跑步获得")])], 1) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "奖牌说明",
      "prop": "badgeExplain"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入奖牌说明",
      "disabled": _vm.actionType === 'detail'
    },
    model: {
      value: (_vm.formData.badgeExplain),
      callback: function($$v) {
        _vm.$set(_vm.formData, "badgeExplain", $$v)
      },
      expression: "formData.badgeExplain"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "H5链接"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入H5链接",
      "disabled": _vm.actionType === 'detail'
    },
    model: {
      value: (_vm.formData.clickLink),
      callback: function($$v) {
        _vm.$set(_vm.formData, "clickLink", $$v)
      },
      expression: "formData.clickLink"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "scheme链接",
      "prop": "newClickLink"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入scheme链接",
      "disabled": _vm.actionType === 'detail'
    },
    model: {
      value: (_vm.formData.newClickLink),
      callback: function($$v) {
        _vm.$set(_vm.formData, "newClickLink", $$v)
      },
      expression: "formData.newClickLink"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "图形",
      "prop": "badgeImage"
    }
  }, [_c('div', {
    staticClass: "flex-row-between"
  }, [_c('div', [_c('div', [_vm._v("勋章图")]), _vm._v(" "), _c('UploadImage', {
    attrs: {
      "actionUrl": "/adminapi/v1/basicTools/upload/one?uploadImageType=4",
      "tips": "(尺寸:200px*200px,jpg、png)",
      "urls": _vm.formData.homeAirdropImage,
      "readonly": _vm.actionType === 'detail'
    },
    on: {
      "onUrls": _vm.homeAirdropImageUploaded
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', [_vm._v("首页弹窗")]), _vm._v(" "), _c('UploadImage', {
    attrs: {
      "actionUrl": "/adminapi/v1/basicTools/upload/one?uploadImageType=4",
      "tips": "(尺寸:200px*200px,jpg、png)",
      "urls": _vm.formData.homeAirdropImageNew,
      "readonly": _vm.actionType === 'detail'
    },
    on: {
      "onUrls": _vm.homeAirdropImageNewUploaded
    }
  })], 1)])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否弹窗"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.formData.isAirdrop),
      callback: function($$v) {
        _vm.$set(_vm.formData, "isAirdrop", $$v)
      },
      expression: "formData.isAirdrop"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "有效时间",
      "prop": "effectiveTime"
    }
  }, [_c('div', {
    staticClass: "flex-row-between"
  }, [_c('el-date-picker', {
    attrs: {
      "placeholder": "起始日期",
      "type": "datetime",
      "disabled": _vm.actionType === 'detail'
    },
    model: {
      value: (_vm.formData.startTime),
      callback: function($$v) {
        _vm.$set(_vm.formData, "startTime", $$v)
      },
      expression: "formData.startTime"
    }
  }), _vm._v(" "), _c('div', [_vm._v("至")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "placeholder": "截止日期",
      "type": "datetime",
      "disabled": _vm.actionType === 'detail'
    },
    model: {
      value: (_vm.formData.endTime),
      callback: function($$v) {
        _vm.$set(_vm.formData, "endTime", $$v)
      },
      expression: "formData.endTime"
    }
  })], 1)])], 1)], 1), _vm._v(" "), (_vm.actionType !== 'detail') ? _c('div', {
    staticClass: "margin-20"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clickSave
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clickSaveAndPublish
    }
  }, [_vm._v("保存并发布")])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-37d7c2a5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/AdvertisingSpace/PingAn/MedalConfigAddition.vue
// module id = 990
// module chunks = 0